export default "__VITE_ASSET__BUlWpLRS__"